import { Component, OnInit } from '@angular/core';
import { CommonService } from '@services/app.common.service';

@Component({
    selector: 'app-sso-login',
    templateUrl: './ssoLogin.component.html',
    styleUrls: ['./ssoLogin.component.css'],
    standalone: false
})
export class SSOLoginComponent  {

  constructor(public common: CommonService) { }



}
